import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import getApiBaseUrl from '@/utils/getBaseUrl';

export default function useGetClients() {
  const { isAuthenticated } = useAuth0();
  const token = window.localStorage.getItem('_token');

  return useQuery({
    queryKey: ['CLIENTS'],
    queryFn: async () => {
      const response = await fetch(`${getApiBaseUrl()}/api/v1/users/clients`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch clients: ${response.statusText}`);
      }

      return (await response.json()).map((c) => ({
        ...c.client,
        accountUserId: c.user?.auth0Id ?? null,
      }));
    },
    enabled: isAuthenticated && !!token,
  });
}
